/**
 * Shared JSON fetch helper for contractor-web APIs.
 * HTTP 204/205 carry no body by definition — never call response.json() on them.
 */
export async function readJson(
  url: string,
  init: RequestInit,
): Promise<{ readonly status: number; readonly ok: boolean; readonly body: unknown }> {
  const response = await fetch(url, init);
  if (response.status === 204 || response.status === 205) {
    return { status: response.status, ok: response.ok, body: null };
  }
  const body: unknown = await response.json();
  return { status: response.status, ok: response.ok, body };
}
